import styled, { css } from 'styled-components';

import SimpleButton from '@components/SimpleButton';

export const Container = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  max-height: 60px;
  box-sizing: border-box;
  max-width: 650px;
  ${({ isHeader }) =>
    !isHeader &&
    css`
      padding: 0 ${({ theme }) => theme.constants.lateralSpace} 16px;
    `};
`;

export const InputSearchContainer = styled.div`
  width: 100%;
  z-index: 1;

  ${({ isHeader, hasFocus, theme }) =>
    isHeader &&
    css`
      width: 100%;
      box-sizing: border-box;
      border: none;
      margin: ${theme.spacing(2, 0, 0, 0)};
      z-index: 1;
      ${hasFocus &&
        css`
          width: 100%;
        `}
    `}
`;

export const CancelButton = styled(SimpleButton)`
  top: 10px;
  right: 7px;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.5s;
  padding-right: 16px;

  ${({ show }) =>
    show &&
    css`
      opacity: 1;
    `}
`;

export const GoBackButton = styled.img`
  cursor: pointer;
`;
